var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"purse-body"},[_c('div',{staticClass:"Content-subject"},[_c('div',{staticClass:"content-box",domProps:{"innerHTML":_vm._s(_vm.dataCom.content)}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }